import classNames from "classnames";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip/index.tsx";
import { useStoryBibleStore } from "../../../stores/storyBibleStore";
import { useSudowriteStore } from "../../../stores/sudowriteStore";
import { StyledContainer } from "./styles";

// Eventually, we can use this as the out of quota tip message
// Need to confirm if a) we want the CTA and b) everyone can access these pages
const outOfQuotaMessage = (
  <>
    You're out of AI words! <a href="/app/plans?ref=bible">Upgrade</a> or <a href="/app/purchase-packs">buy a word pack</a> to generate.
  </>
);

function HoverTippable({ generateDisabled, generateDisabledMessage, children, submenuActive, id, outOfQuotaOverride }) {
  const requesting = useStoryBibleStore((state) => state.requesting);
  const storeOutOfQuota = useStoryBibleStore((state) => state.outOfQuota);
  const outOfQuota = outOfQuotaOverride ?? storeOutOfQuota;
  const subscription = useSudowriteStore((state) => state.subscription);

  const disabled = requesting || outOfQuota || generateDisabled;
  const wordOrCredit = subscription.isV4 ? "credit" : "AI word";

  let tipMessage;

  if (requesting) {
    tipMessage = "The AI is busy with something else. Wait a few minutes to generate.";
  } else if (outOfQuota) {
    tipMessage = `You're out of ${wordOrCredit}s. Upgrade or buy a ${wordOrCredit} pack to generate.`;
  } else if (generateDisabled) {
    tipMessage = generateDisabledMessage;
  } else {
    tipMessage = null;
  }

  // Check if tipMessage is a string or JSX
  const isStringMessage = typeof tipMessage === "string";
  const hasTipMessage = tipMessage !== null && tipMessage !== undefined && tipMessage !== "";

  return (
    <SudoTooltip
      text={isStringMessage ? tipMessage : ""}
      customContent={!isStringMessage && hasTipMessage ? tipMessage : undefined}
      disabled={!!submenuActive || !hasTipMessage}
      position="top"
    >
      <StyledContainer
        id={id}
        className={classNames({ disabled: generateDisabled })}
      >
        {children}
        {disabled && (
          <div className={classNames("disabled-hover-target", { "submenu-active": submenuActive })}>
            <div className="invisible-padding"></div>
          </div>
        )}
      </StyledContainer>
    </SudoTooltip>
  );
}

export default HoverTippable;
